import React from 'react'
import styled from 'styled-components'
import { Grid as BaseGrid } from '@material-ui/core'
import { WarningIcon as BaseWarningIcon } from '@chilecompra/react-kit/components'

export const Body = styled(BaseGrid)``

export const ButtonsContainer = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  grid-column-gap: 15px;

  ${props => props.theme.breakpoints.down('xs')} {
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: auto auto;
    grid-row-gap: 15px;
  }
`

export const ClaveUnicaImage = styled.img`
  height: 20px;
`

export const Link = styled.a``

export const Row = styled(({ ...props }) => <BaseGrid {...props} container />)``

export const Column = styled(({ ...props }) => <BaseGrid {...props} item />)``

export const Root = styled.div`
  margin: 0;
  width: 100%;
`

export const Section = styled.section`
  font-size: ${props => props.fontSize};
  line-height: ${props => props.lineHeight};
  margin-top: ${props => props.marginTop || '28px'};

  ${props => props.theme.breakpoints.down('xs')} {
    text-align: center;
  }
`

export const SectionAlert = styled.section`
  display: flex;
`
export const Strong = styled.b`
  font-weight: 700;
`

export const Title = styled.h1`
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 34px;
  font-weight: 300;
  line-height: 45px;

  ${props => props.theme.breakpoints.down('xs')} {
    text-align: center;
  }
`
export const WarningIcon = styled(BaseWarningIcon)`
  &.MuiSvgIcon-root {
    color: ${props => props.theme.palette.brand.warning};
    font-size: 1.2rem;
    margin-right: 12px;
  }
`
export const WelcomeImage = styled.img`
  width: 100%;
  ${props => props.theme.breakpoints.down('xs')} {
    max-width: 140px;
    display: block;
    margin: 0 auto;
  }
`
